import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class Logger {
  error(message: string, data?: unknown) {
    console.error(`Error: ${message}`, data);
  }

  warning(message: string, data?: unknown) {
    console.warn(`Warning: ${message}`, data);
  }

  info(message: string, data?: {}) {
    console.info(`Info: ${message}`, data);
  }
}
